"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _Pipes = require("../HtgSub/Pipes");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _Device = _interopRequireDefault(require("../Models/Device"));
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _models = require("../../models");
var _constants = require("../../../utils/constants");
var _WallModel = require("../Models/WallModel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  LoopType,
  SectionTypes,
  sensorTypes,
  ComponentTypes,
  modelsWithVersion
} = _paulCorePackage.constants;
const Item = _ref => {
  let {
    id,
    position = [0, 0, 0],
    isLast = false
  } = _ref;
  const type = ComponentTypes.HtgSys;
  const {
    thingHtgSysHeatGenerator: {
      id: generatorKey = null
    } = {},
    thingHtgSysEnergySource: {
      id: sourceKey = null
    } = {},
    thingHtgSysDistrictHeatingType: {
      id: typeKey = null
    } = {}
  } = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id
  }) || {};
  // const {
  //   thingHtgSysHeatGenerator: { id: generatorKey = null } = {},
  //   thingHtgSysEnergySource: { id: sourceKey = null } = {},
  //   thingHtgSysDistrictHeatingType: { id: typeKey = null } = {},
  // } = {
  //   thingHtgSysHeatGenerator: { id: 2, value: {} },
  //   thingHtgSysEnergySource: { id: 9, value: {} },
  //   thingHtgSysDistrictHeatingType: { id: null, value: {} },
  // };
  const showBox = false;
  const isActiveVariant = (0, _react.useCallback)(config => config.htgSysGeneratorKey === Number(generatorKey) && (sourceKey !== null ? config.htgSysSourceKey.includes(Number(sourceKey)) : true) && (typeKey !== null ? config.htgSysTypeKey === Number(typeKey) : true), [generatorKey, sourceKey, typeKey]);
  return (0, _react.useMemo)(() => {
    if (generatorKey <= 0) {
      return /*#__PURE__*/_react.default.createElement("group", {
        position: position
      }, /*#__PURE__*/_react.default.createElement(_Pipes.Pipes, {
        position: [0, 0, 0]
      }), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
        position: [0, 10, -23],
        scale: [1, 1, 0.8],
        rotation: [0, 0, 0],
        highlightsType: _constants.pipesTypes.heatingReturn
      }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
        position: [0, 20, -23],
        scale: [1, 1, 0.8],
        rotation: [0, 0, 0],
        highlightsType: _constants.pipesTypes.heatingFlow
      })));
    }
    return /*#__PURE__*/_react.default.createElement("group", {
      dispose: null,
      position: position
    }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 10, -7.5],
      showBox: showBox,
      visible: true,
      pipe: _constants.pipesTypes.heatingReturn
    }, /*#__PURE__*/_react.default.createElement(_Device.default, {
      equipmentId: id,
      equipmentType: type,
      thingLoopType: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect) ? LoopType.secondary : LoopType.none,
      thingSectionType: SectionTypes.return,
      requiredTypeNot: sensorTypes.pump,
      panelProps: {
        secondPosition: _constants.panelPosition.top
      }
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 10, -18],
      showBox: showBox,
      visible: !isActiveVariant(_constants.htgSysConfig.districtHeatingDirect) && !isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect),
      pipe: _constants.pipesTypes.heatingReturn
    }, /*#__PURE__*/_react.default.createElement(_Device.default, {
      equipmentId: id,
      equipmentType: type,
      thingLoopType: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect) ? LoopType.secondary : LoopType.none,
      thingSectionType: SectionTypes.return,
      requiredType: sensorTypes.pump,
      anywayShow: true
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 20, -7.5],
      showBox: showBox,
      visible: true,
      pipe: _constants.pipesTypes.heatingFlow
    }, /*#__PURE__*/_react.default.createElement(_Device.default, {
      equipmentId: id,
      equipmentType: type,
      thingLoopType: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect) ? LoopType.secondary : LoopType.none,
      thingSectionType: SectionTypes.flow,
      modelProps: {
        [sensorTypes.energyValve]: {
          activeCable: _constants.activeCableDirection.bottom
        },
        [sensorTypes.temperatureSensor]: {
          [modelsWithVersion.paulTemperature_v1]: {
            activeCable: _constants.activeCableDirection.vertical
          }
        }
      },
      panelProps: {
        secondPosition: _constants.panelPosition.bottom
      }
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 15, -25],
      args: [3, 15, 6],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect)
    }, /*#__PURE__*/_react.default.createElement(_models.HeatExchangerModel, {
      position: [0, 5, 0]
    })), /*#__PURE__*/_react.default.createElement("group", {
      visible: !isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect)
    }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 10, -23],
      scale: [1, 1, 0.8],
      rotation: [0, 0, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 20, -23],
      scale: [1, 1, 0.8],
      rotation: [0, 0, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 10, -35],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect),
      pipe: _constants.pipesTypes.heatingReturn
    }, /*#__PURE__*/_react.default.createElement(_Device.default, {
      equipmentId: id,
      equipmentType: type,
      thingLoopType: LoopType.primary,
      thingSectionType: SectionTypes.return
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 20, -35],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect),
      pipe: _constants.pipesTypes.heatingFlow
    }, /*#__PURE__*/_react.default.createElement(_Device.default, {
      equipmentId: id,
      equipmentType: type,
      thingLoopType: LoopType.primary,
      thingSectionType: SectionTypes.flow
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 12.5, -48],
      args: [19, 26, 19],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.renewableDistrictHeating)
    }, /*#__PURE__*/_react.default.createElement(_models.BoilerGasModel, {
      position: [0, -2.5, 0]
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 12.5, -48],
      args: [19, 26, 19],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.renewableHeating)
    }, /*#__PURE__*/_react.default.createElement(_models.BhkwModel, {
      position: [0, -2.5, 0],
      color: "#59A5C6"
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [-3, 15, -45],
      args: [10, 22, 16],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.districtHeatingDirect) || isActiveVariant(_constants.htgSysConfig.districtHeatingIndirect)
    }, /*#__PURE__*/_react.default.createElement(_models.DistrictHeatingModel, {
      position: [-3, 5, -2]
    }), /*#__PURE__*/_react.default.createElement("group", {
      position: [3, -5, 5]
    }, /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 0, 0]
    }, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [0, 0, -6],
      rotation: [0, 0, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-1.1, 0, -7],
      scale: [1, 1, 0.7],
      rotation: [0, Math.PI / 2, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    })), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 10, 0]
    }, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [0, 0, -6],
      rotation: [0, 0, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-1.1, 0, -7],
      scale: [1, 1, 0.7],
      rotation: [0, Math.PI / 2, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    })))), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 30, -45],
      visible: isActiveVariant(_constants.htgSysConfig.renewableSolar) || isActiveVariant(_constants.htgSysConfig.renewableAirHeatPump) || isActiveVariant(_constants.htgSysConfig.renewableWaterHeatPump) || isActiveVariant(_constants.htgSysConfig.renewableBrineHeatPump)
    }, /*#__PURE__*/_react.default.createElement(_WallModel.WallModel, {
      position: [-3, 14.9, 13],
      args: [21, 0.2, 28]
    }), /*#__PURE__*/_react.default.createElement(_WallModel.WallModel, {
      position: isLast ? [-13.5, 19.8, 13] : [-13.5, 16.8, 13],
      rotation: [0, 0, Math.PI / 2],
      args: isLast ? [10, 0.2, 28] : [4, 0.2, 28]
    }), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, -20, 5]
    }, /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 0, 0]
    }, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [0, 0, -6],
      rotation: [0, 0, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [-1, 0, -7],
      rotation: [-Math.PI / 2, Math.PI / 2, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-2, 1, -7],
      scale: [1, 1, 6.7],
      rotation: [Math.PI / 2, 0, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [-2, 35.6, -6],
      rotation: [0, 0, Math.PI / 2],
      highlightsType: _constants.pipesTypes.heatingReturn
    })), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 10, -7]
    }, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [0, 1, 0],
      rotation: [-Math.PI / 2, 0, Math.PI / 2],
      highlightsType: _constants.pipesTypes.heatingFlow
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 1, 0],
      scale: [1, 1, 4.7],
      rotation: [Math.PI / 2, 0, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
      position: [0, 25.6, 1],
      rotation: [0, 0, Math.PI / 2],
      highlightsType: _constants.pipesTypes.heatingFlow
    })))), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [0, 11.5, -34],
      args: [8.2, 23, 8.2],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.renewableAirHeatPump) || isActiveVariant(_constants.htgSysConfig.renewableWaterHeatPump) || isActiveVariant(_constants.htgSysConfig.renewableBrineHeatPump)
    }, /*#__PURE__*/_react.default.createElement(_models.HeatPumpBaseModel, {
      position: [0, -1.5, 0]
    })), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 10, -46],
      visible: isActiveVariant(_constants.htgSysConfig.renewableSolar)
    }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [-3, 40, 14],
      args: [16, 10, 25],
      showBox: showBox
    }, /*#__PURE__*/_react.default.createElement(_models.SolarThermalModel, {
      position: [0, -5, 0],
      scale: [2, 2, 2]
    })), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-2, 35.6, 0],
      scale: [1, 1, 2.4],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 35.6, 0],
      scale: [1, 1, 2.4],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    })), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 10, -46],
      visible: isActiveVariant(_constants.htgSysConfig.renewableAirHeatPump)
    }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [-3, 40, 12],
      args: [16, 10, 25],
      showBox: showBox
    }, /*#__PURE__*/_react.default.createElement(_models.HeatPumpModel, {
      position: [0, 5, 9],
      rotation: [0, -Math.PI / 2, 0]
    })), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-2, 35.6, 0],
      scale: [1, 1, 2],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 35.6, 0],
      scale: [1, 1, 2],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [-2.5, 46.4, -34.1],
      args: [17.2, 3, 23],
      showBox: showBox,
      visible: isActiveVariant(_constants.htgSysConfig.renewableWaterHeatPump)
    }, /*#__PURE__*/_react.default.createElement(_models.HeatPumpEarthModel, {
      position: [2.5, 8.3, 3],
      rotation: [0, 0, 0],
      scale: [0.95, 0.95, 0.95]
    })), /*#__PURE__*/_react.default.createElement("group", {
      position: [0, 10, -46],
      visible: isActiveVariant(_constants.htgSysConfig.renewableBrineHeatPump)
    }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
      position: [-3, 40, 14],
      args: [16, 10, 25],
      showBox: showBox
    }, /*#__PURE__*/_react.default.createElement(_models.HeatPumpWaterModel, {
      position: [3, 5, 0],
      rotation: [0, 0, 0]
    })), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [-2, 35.6, 0],
      scale: [1, 1, 1.3],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingReturn
    }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
      position: [0, 35.6, 0],
      scale: [1, 1, 1.3],
      rotation: [0, Math.PI, 0],
      highlightsType: _constants.pipesTypes.heatingFlow
    })), /*#__PURE__*/_react.default.createElement(_Pipes.Pipes, {
      position: [0, 0, 0]
    }));
  }, [generatorKey, position, showBox, id, type, isActiveVariant, isLast]);
};
exports.Item = Item;